import React from 'react';
import ReactDOM from 'react-dom/client';
import { addCollection } from '@iconify/react';
import lineMdIcons from '@iconify-json/line-md/icons.json';
import App from './App.tsx';
import { ScreenErrorBoundary } from './components/core/ScreenErrorBoundary';
import './index.css';
import { installCrashHandlers } from './utils/crash-handlers';

installCrashHandlers();
addCollection(lineMdIcons);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ScreenErrorBoundary>
      <App />
    </ScreenErrorBoundary>
  </React.StrictMode>
);
